import EditorImg from 'lowcode/components/EditorImg';
import { FC } from 'react';
import EditorLink from 'lowcode/components/EditorLink';
import NeedLoginShow from 'elem/compCommon/NeedLoginShow';
import NoneLoginShow from 'elem/compCommon/NoneLoginShow';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';

interface TheProps {
    callback?: () => void; // 新品订阅
}

const TheComp: FC<TheProps> = ({ callback }) => {
    const { locale } = getLocal();
    const { t } = useLang('membersday.end.ReferralNextEnd');
    const getBannerImg = (locale: string) => {
        const defaultImg = {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1713153116815/20231017-173112.png',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1713153271473/20231017-173112%20(1).png',
        };
        const imgs: Record<string, any> = {
            jp: {
                pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1714362084675/member_jp_end_pc.jpg',
                h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1714362065928/member_jp_end_h5.jpg',
            },
        };

        return imgs[locale] || defaultImg;
    };
    const imgRef = getBannerImg(locale);
    return (
        <div className={styles.comp} id="ReferralNextEnd">
            <div className="members-day-over"></div>
            <div className="members-day-inter">
                <EditorImg pc={imgRef.pc} h5={imgRef.h5} />
                <div className="box-a">
                    <div className="box-a-in">
                        <div className="box-a-title">{t('title')}</div>
                        <EditorLink className="box-a-btn" href={`/${locale}/referral`}>
                            <NeedLoginShow>{t('btn2')}</NeedLoginShow>
                            <NoneLoginShow>{t('btn1')}</NoneLoginShow>
                        </EditorLink>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TheComp;
